// Ergebnis-Karte nach einem Import (Prototyp Belegung/CSV): großes Icon, Text aus dem Code, Kennzahlen.
import type { ReactNode } from 'react';
import type { Icon } from '@phosphor-icons/react';
import { ABSCHNITT, FORM, GLANZ } from './form-stil';

export interface FormErgebnisProps {
  icon: Icon;
  verlauf: string;
  /** Tönung der Karte oben links */
  toenung: string;
  titel?: ReactNode;
  children?: ReactNode;
}

export function FormErgebnis({ icon: I, verlauf, toenung, titel, children }: FormErgebnisProps) {
  return (
    <section className="pf-rise relative flex shrink-0 flex-col items-center overflow-hidden text-center" style={{
      gap: 14, padding: '26px 18px', borderRadius: ABSCHNITT.radius,
      background: `linear-gradient(165deg,${toenung},rgba(255,255,255,0.035) 55%,rgba(255,255,255,0.02))`, boxShadow: ABSCHNITT.schatten,
    }}>
      <span aria-hidden className="relative flex shrink-0 items-center justify-center overflow-hidden" style={{
        width: 64, height: 64, borderRadius: 20, background: verlauf,
        boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.5),inset 0 -2px 4px rgba(0,0,0,0.2),0 8px 16px -8px rgba(0,0,0,0.6)',
      }}>
        <span className="absolute inset-0" style={{ background: GLANZ }} />
        <span className="absolute rounded-full" style={{ width: 45, height: 45, right: -14, bottom: -16, background: 'rgba(255,255,255,0.16)' }} />
        <I size={32} weight="fill" color="#fff" className="relative" />
      </span>
      {titel && <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1.4, color: FORM.text }}>{titel}</h3>}
      {children}
    </section>
  );
}

/** Kennzahl-Kachel in der Ergebnis-Karte. */
export function FormKennzahl({ wert, label, farbe }: { wert: ReactNode; label: string; farbe?: string }) {
  return (
    <div className="pf-pop flex flex-col items-center" style={{
      gap: 6, padding: '14px 10px', borderRadius: 18, background: 'rgba(255,255,255,0.05)',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.1),inset 0 0 0 0.5px rgba(255,255,255,0.06)',
    }}>
      <span style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.03em', color: farbe ?? FORM.text, fontVariantNumeric: 'tabular-nums' }}>{wert}</span>
      <span style={{ fontSize: 11.5, fontWeight: 700, color: 'rgba(255,255,255,0.55)' }}>{label}</span>
    </div>
  );
}
